module.exports = __webpack_public_path__ + "static/media/search.f94e281e.svg";